import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { UIState } from "./types";

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      error: null,
      isLoading: false,
      collectionViewMode: "grid",
      setError: (error) => set({ error }),
      clearError: () => set({ error: null }),
      setLoading: (isLoading) => set({ isLoading }),
      setCollectionViewMode: (collectionViewMode) =>
        set({ collectionViewMode }),
    }),
    {
      name: "ui-preferences",
      partialize: (state) => ({
        collectionViewMode: state.collectionViewMode,
      }),
    }
  )
);
